/* REACT PACKAGE IMPORTS */
import React, { useState, useEffect, useRef, useCallback } from "react";
import { Button } from "react-bootstrap";

/* MUI PACKAGE IMPORTS */
import { Tooltip } from "@mui/material";

/* INTERNAL IMPORTS */
import SideModal from "./SideModal";
import PinInput from "../PinInput";
import CountdownTimer from "../Timer";

import { addLineBreak } from "../../Utilities/format";

export default function SessionDetails({
  sessionId,
  sessionState,
  sessionStatus,
}) {
  const { details, examDuration } = sessionState;
  const { title, startTime, instructions, description, passmark } = details;

  const studyMaterialsArray = [
    {
      link: "https://digitalhub.fifa.com/m/1c21b25b00c6dec8/original/FIFA-Football-Agent-Exam-Study-Materials.pdf",
      title: "Study Materials March 26 Edition (EN)",
    },
    {
      link: "https://digitalhub.fifa.com/m/1009119579a8c8c4/original/Materiales-de-estudio-sobre-el-examen-de-la-FIFA-para-agentes-de-futbol.pdf",
      title: "Study Materials March 26 Edition (ES)",
    },
    {
      link: "https://digitalhub.fifa.com/m/6461f8f0ff0ee7d1/original/Materiel-pedagogique-de-l-examen-de-la-FIFA-pour-les-agents.pdf",
      title: "Study Materials March 26 Edition (FR)",
    },
  ];

  const modalTitleStyling = "text-lg mb-0";
  const modalContentStyling = "";
  const modalDivStyling = "my-3";

  const [isDetailsVisible, setIsDetailsVisible] = useState(false);
  const mounted = useRef(null);

  const handleSessionExpired = useCallback((expired) => {
    // setExpired(expired);
  }, []);

  useEffect(() => {
    mounted.current = true;
    if (!mounted.current) return;
    setIsDetailsVisible(
      sessionStatus === "pending" || sessionStatus === "future",
    );
    return () => (mounted.current = false);
  }, [sessionStatus]);

  return (
    <>
      <Button
        className="px-3 py-2 inter"
        variant="outline-dark"
        onClick={() => setIsDetailsVisible(true)}
      >
        Details
      </Button>
      <SideModal
        title={"Assessment Details"}
        isVisible={isDetailsVisible}
        setIsVisible={setIsDetailsVisible}
      >
        <div className={"mb-2"}>
          <h2 className={modalTitleStyling}>Title</h2>
          <p className="text-">
            {title ? (
              title
            ) : (
              <span className="text-muted fst-italic">No title set</span>
            )}
          </p>
        </div>
        {description ? (
          <div className={modalDivStyling}>
            <h2 className={modalTitleStyling}>Description</h2>
            <p className="text-base">{description}</p>
          </div>
        ) : null}
        <div className={modalDivStyling}>
          <h2 className={modalTitleStyling}>Instructions</h2>
          <p className="inter-light">
            {instructions ? (
              addLineBreak(instructions)
            ) : (
              <span className="text-muted fst-italic">No instructions set</span>
            )}
          </p>
        </div>
        <div className={modalDivStyling}>
          <h2 className={modalTitleStyling}>Study Materials</h2>
          <p className={"text-muted p-0 mb-1"}>
            Select a study guide link from below
          </p>
          <ul className="list-none">
            {studyMaterialsArray.map(({ link, title }, i) => {
              return (
                <li key={i}>
                  <Tooltip
                    placement="left"
                    title="This link will open the Study Materials in a new window."
                  >
                    <a
                      className="!text-black hover:!text-gray-500 underline inter-light"
                      href={link}
                      target="_blank"
                    >
                      {title}
                    </a>
                  </Tooltip>
                </li>
              );
            })}
          </ul>
        </div>
        <div className={modalDivStyling}>
          <h2 className={modalTitleStyling}>Duration</h2>
          <p className="text-base">{examDuration}</p>
        </div>
        <div className={modalDivStyling}>
          <h2 className={modalTitleStyling}>Pass mark</h2>
          <p className="text-base">{passmark}</p>
        </div>
        {sessionStatus === "future" && (
          <CountdownTimer
            sessionStatus={"pending"}
            targetDate={startTime}
            sessionExpired={sessionStatus === "pending"}
            setSessionExpired={handleSessionExpired}
            paused={false}
          />
        )}
        {sessionStatus === "pending" && (
          <div className={modalDivStyling}>
            <h2 className="text-lg mb-1">PIN</h2>
            <PinInput sessionId={sessionId} sessionState={sessionState} />
          </div>
        )}
      </SideModal>
    </>
  );
}
